import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { getFirebaseConfig } from './remoteConfig';

let analytics = null;

/**
 * Inicializa Firebase Analytics si el entorno actual lo soporta (navegador).
 */
export async function initAnalytics() {
  try {
    const supported = await isSupported();
    if (supported) {
      const config = getFirebaseConfig();
      const app = !getApps().length ? initializeApp(config) : getApps()[0];
      analytics = getAnalytics(app);
      // eslint-disable-next-line no-console
      console.log(`[Analytics] Firebase Analytics inicializado para el proyecto: ${config.projectId}`);
      return analytics;
    }
    // eslint-disable-next-line no-console
    console.warn('[Analytics] Firebase Analytics no es compatible con el entorno actual.');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[Analytics] Error al inicializar Firebase Analytics:', error.message || error);
  }
  return null;
}

/**
 * Registra un evento en Firebase Analytics de forma segura.
 * @param {string} eventName - Nombre del evento.
 * @param {Object} [eventParams={}] - Parámetros del evento.
 */
export function logAnalyticsEvent(eventName, eventParams = {}) {
  if (analytics) {
    try {
      logEvent(analytics, eventName, eventParams);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(`[Analytics] Error al registrar evento ${eventName}:`, error.message || error);
    }
  }
}
